'use client'
import Image from 'next/image'
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'
import { PrismicRichText } from '@prismicio/react'
import { usePathname, useRouter } from 'next/navigation'
import { trackEvent } from '@/utils/analytics'

type DataObject = Record<string, any>

const RecommendedReadingComponent = ({ data }: { data: DataObject }) => {
  const router = useRouter()
  const pathname = usePathname()

  const recommendedReadingData = {
    title: data.section_title[0]?.text,
    content: data.article_title[0]?.text,
    srcPath: `https://secureframe.com${pathname}`,
    destPath:
      data.article_link.link_type !== 'Web' ? <PrismicNextLink field={data.article_link} /> : data.article_link.url,
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    router.push(recommendedReadingData.destPath)

    trackEvent('Recommended Reading Clicked', recommendedReadingData)
  }

  return (
    <div className="my-10 rounded-md border border-secondary-gray-150 p-8 shadow-light backdrop-blur-25">
      <div className="[&>h2]:my-0 [&>h2]:text-3xl">
        <PrismicRichText field={data.section_title} />
      </div>

      <div className="flex flex-col items-center md:flex-row">
        <div className="mb-5 w-full md:mb-0 md:w-[30%] [&>img]:w-full [&>img]:rounded-md">
          <PrismicNextImage field={data.article_image} width={180} height={125} fallbackAlt="" />
        </div>

        <div className="w-full md:w-[70%] md:pl-8 [&>p]:mb-4 [&>p]:text-xl">
          <PrismicRichText field={data.article_title} />

          <button className="btn btn-secondary btn-default btn-interaction inline-block !w-fit" onClick={handleClick}>
            Read article
            <Image src="/images/angle-right-black.svg" width={20} height={16} alt="" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default RecommendedReadingComponent
